import { supabase } from "../../lib/supabaseClient";

/**
 * Extrai melhor possível o nome exibível dos metadados.
 */
export function deriveDisplayName(user: any): string {
  return (
    user?.user_metadata?.full_name ||
    user?.user_metadata?.name ||
    user?.user_metadata?.given_name ||
    user?.user_metadata?.family_name ||
    "—"
  );
}

/**
 * Atualiza campos permitidos do profile.
 */
export async function updateProfile(userId: string, fields: { full_name?: string; phone?: string }) {
  try {
    const payload: Record<string, any> = {};
    if (fields.full_name !== undefined) payload.full_name = fields.full_name;
    if (fields.phone !== undefined) payload.phone = fields.phone;

    if (Object.keys(payload).length === 0) {
      console.log("[PROFILE] No fields to update");
      return;
    }

    console.log("[PROFILE] Updating profile:", userId, payload);
    const { error } = await supabase.from("profile").update(payload).eq("user_id", userId);

    if (error) {
      console.error("[PROFILE] Update error:", error);
      throw new Error(error.message);
    }
    console.log("[PROFILE] Update successful");
  } catch (err) {
    console.error("[PROFILE] updateProfile error:", err);
    throw err;
  }
}

/**
 * Busca dados atuais do profile.
 */
export async function fetchProfile(userId: string) {
  try {
    console.log("[PROFILE] Fetching profile for:", userId);
    const { data, error } = await supabase
      .from("profile")
      .select("full_name, email, phone, avatar_url, plan, payment_status")
      .eq("user_id", userId)
      .limit(1);

    if (error) {
      console.error("[PROFILE] Fetch error:", error);
      throw new Error(error.message);
    }
    console.log("[PROFILE] Fetch successful:", data?.[0] ? "found" : "not found");
    return data?.[0] || null;
  } catch (err) {
    console.error("[PROFILE] fetchProfile error:", err);
    throw err;
  }
}

/**
 * Verifica se existem campos obrigatórios faltando.
 * Obtém lista de VITE_REQUIRED_PROFILE_FIELDS (ex: "full_name,phone").
 */
export function needsCompletion(profile: any): boolean {
  try {
    const requiredRaw = import.meta.env.VITE_REQUIRED_PROFILE_FIELDS || "";
    const required = requiredRaw
      .split(",")
      .map((s) => s.trim())
      .filter(Boolean);

    if (!profile) {
      console.log("[PROFILE] needsCompletion: no profile, assuming incomplete");
      return true;
    }

    const incomplete = required.some((field) => {
      const value = profile[field];
      const missing = value === null || value === undefined || value === "" || value === "—";
      if (missing) {
        console.log("[PROFILE] needsCompletion: missing field:", field);
      }
      return missing;
    });
    
    console.log("[PROFILE] needsCompletion:", incomplete);
    return incomplete;
  } catch (err) {
    console.error("[PROFILE] needsCompletion error:", err);
    // Em caso de erro, assumir que está incompleto para segurança
    return true;
  }
}
